import { UseUpdateOnAppStateChange } from './types';

export const useUpdateOnAppStateChange: UseUpdateOnAppStateChange = () => {};
